import { createElement, forwardRef } from 'react';
import { commonScrollbar } from '../patterns/common-scrollbar.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const CommonScrollbar = /* @__PURE__ */ forwardRef(function CommonScrollbar(props, ref) {
  const [patternProps, restProps] = splitProps(props, commonScrollbar.propKeys)
  const styleProps = commonScrollbar.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})